export const ROUTE_INSPECTIONS = '/customer/all/request?';
export const ROUTE_CUSTOMER = '/customer/:userIdentity';
export const ROUTE_INSPECTION_STATE = '/customer/:userIdentity/inspections-request/:requestId/states';
export const ROUTE_INSPECTION_INFO = '/customer/:userIdentity/inspections-request/:requestId';
export const ROUTE_INSPECTION_PICTURES = '/customer/:userIdentity/inspections-request/:requestId/pictures';
export const ROUTE_INSPECTION_PICTURES_DAMAGES = '/customer/:userIdentity/inspections-request/:requestId/damages';
export const ROUTE_INSPECTION_POLICY = '/policy/:policyNumber';
export const ROUTE_INSPECTION_ACCESORIES = '/customer/:userIdentity/inspections-request/:requestId/accessories';
export const ROUTE_INSPECTION_COMMENTS_DAMAGES = '/customer/:userIdentity/inspections-request/:requestId/damageComment';
export const ROUTE_INSPECTION_COMMENTS_GENERAL = '/customer/:userIdentity/inspections-request/:requestId/generalComment';
export const ROUTE_INSPECTION_APPROVED = '/customer/:userIdentity/inspections-request/:requestId/approved';

export const ROUTE_INSPECTION_RETURN_TO_APPROVED = '/customer/:userIdentity/inspections-request/:requestId/return-to-approved';
export const ROUTE_INSPECTION_RETURN_TO_IN_PERSON = '/customer/:userIdentity/inspections-request/:requestId/return-in-person';
export const ROUTE_INSPECTION_IN_PERSON_TO_CREATE = '/customer/:userIdentity/inspections-request/:requestId/in-person-created';
/*Ruta del servicio in perto to return*/
export const ROUTE_INSPECTION_IN_PERSON_TO_RETURN = '/customer/:userIdentity/inspections-request/:requestId/in-person-return';
export const ROUTE_INSPECTION_UPDATE_VEHICLE_PLATE = '/customer/:userIdentity/inspections-request/:requestId/vehicle-plate';
export const ROUTE_INSPECTION_REMOVE_INSPECTIONS = '/customer/inspections-request/remove';

export const ROUTE_INSPECTION_PRESENCIAL = '/customer/:userIdentity/inspections-request/:requestId/presential';
export const ROUTE_INSPECTION_REJECTED = '/customer/:userIdentity/inspections-request/:requestId/rejected';
export const ROUTE_INSPECTION_RETURN = '/customer/:userIdentity/inspections-request/:requestId/return';
export const ROUTE_INSPECTION_PICTURES_OBSERVED = '/customer/:userIdentity/inspections-request/:requestId/observed';
export const ROUTE_INSPECTION_DERIVE = '/customer/:userIdentity/inspections-request/:requestId/derive';
export const ROUTE_INSPECTION_REPORT = '/upload/pacific/report';
export const ROUTE_LOGIN = '/sign/in';
export const ROUTE_ME = '/users/me';
export const ROUTE_TOKEN = '';


// WEBPACK FOOTER //
// ./src/constants/routes/routes-service.js